
/**
 * Legal document versions for compliance tracking
 * Update these when terms of service or privacy policy change
 */
export const LEGAL_VERSIONS = {
  TERMS_OF_SERVICE: '2025-09-04',
  PRIVACY_POLICY: '2025-09-04',
} as const;

export type LegalAgreementAcceptance = {
  timestamp: string;
  terms_version: string;
  privacy_version: string;
  ip_address?: string;
  user_agent?: string;
};
